import {articleDetail} from "../../../api/server/article"
import commonMixin from "../../../mixin/common"
import Nomsg from "../../../components/Nomsg"
export default {
  name: 'IndexPage',
  mixins: [commonMixin],
  data () {
    return {
      id: null,
      info: null
    }
  },
  components: {
    nomsg: Nomsg
  },
  computed: {
  },
  methods: {
    _getDetail () {
      let id = this.id
      if (id) {
        let query = {
          id: id
        }
        articleDetail(query).then((res) => {
          if (res.code === 200 && res.data) {
            this.info = res.data
          } else {
            this.id = null
            this.info = null
          }
        })
      }
    },
    reset () {
      this._getDetail()
    },
    handleRoute (route) {
      if (route.name === 'news-detail') {
        let id = this.$route.query.id
        this.id = id
        this.reset()
      }
    }
  },
  watch: {
    'route' (to, from) {
      this.handleRoute(to)
    }
  },
  mounted: function () {
    this.handleRoute(this.$route)
  }
}